module.exports = __webpack_public_path__ + "static/img/leisure-main-img02.4328a13a.png";